"use client"

import DashboardLayout from "../../components/Layout/DashboardLayout"
import MiniFooter from "../../components/Layout/miniFooter"

export default function ComingSoon() {
  return (
    <DashboardLayout>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #ffffffff, #F9FAFB)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "24px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            background: "#FFFFFF",
            border: "1px solid #E5E7EB",
            borderRadius: "16px",
            padding: "40px 32px",
            maxWidth: "440px",
            width: "100%",
            boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
          }}
        >
          {/* Icon */}
          <div
            style={{
              width: "56px",
              height: "56px",
              background: "#EEF2FF",
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#4F46E5"
              strokeWidth="2"
            >
              <path d="M12 2v4" />
              <path d="M12 18v4" />
              <path d="M4.93 4.93l2.83 2.83" />
              <path d="M16.24 16.24l2.83 2.83" />
              <path d="M2 12h4" />
              <path d="M18 12h4" />
              <path d="M4.93 19.07l2.83-2.83" />
              <path d="M16.24 7.76l2.83-2.83" />
            </svg>
          </div>

          <h1
            style={{
              fontSize: "26px",
              fontWeight: "700",
              color: "#111827",
              marginBottom: "8px",
            }}
          >
            Coming Soon
          </h1>

          <p
            style={{
              fontSize: "15px",
              color: "#6B7280",
              marginBottom: "18px",
            }}
          >
            This feature is currently under active development. We are working
            hard to deliver it as soon as possible.
          </p>

          {/* Company Information */}
          <p
            style={{
              fontSize: "14px",
              color: "#6B7280",
              marginBottom: "24px",
              lineHeight: "1.6",
            }}
          >
            <strong style={{ color: "#111827" }}>u2lr</strong> is built and
            maintained by <strong>u2lr Software Inc.</strong>, focused on secure
            link shortening, analytics, and scalable URL management for modern
            teams.
          </p>

          <span
            style={{
              display: "inline-block",
              padding: "6px 14px",
              background: "#EEF2FF",
              color: "#4338CA",
              borderRadius: "999px",
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            Stay tuned
          </span>
        </div>
      </div>

      <MiniFooter />
    </DashboardLayout>
  )
}